export const REVISE_VIDEOS_PLAYLIST_TYPE_ID = 666;
